import Handlebars from 'handlebars';
import $ from 'jquery';

export function render(parameters){
  $('#view .view__hbs').empty();
  var context = parameters;
  $('#view .view__hbs').append(Handlebars.templates.MapTemplate(context));
}

export default {
  render
};
